import React from "react";

/**
 * Upload button with icon used in filing section headers.
 * Shows only when `show` is true (typically when !isCpa && needsAttention).
 */
export const SectionUploadButton = ({ show, onClick, label = "Upload" }) => {
  if (!show) return null;
  return (
    <button type="button" className="section-header-upload" onClick={onClick}>
      <img
        src={`${process.env.PUBLIC_URL}/images/icons/upload_primary_blue.svg`}
        alt="Upload"
        className="section-header-upload-icon"
      />
      {label}
    </button>
  );
};

/**
 * Required / Submitted counter row used below section headers.
 */
export const SectionMetaRow = ({ required, provided }) => (
  <div className="section-meta-row">
    <span className="section-meta-item">
      <span className="section-meta-label">Required:</span>
      <span className="section-meta-value">{required}</span>
    </span>
    <span className="section-meta-item">
      <span className="section-meta-label">Submitted:</span>
      <span className="section-meta-value">{provided}</span>
    </span>
  </div>
);
